import { useEffect, useState } from "react";
import { ChefHat, ExternalLink } from "lucide-react";
import { api } from "../lib/api";

// Shows the item's recipe status and opens it in the Kitchen module.
export const RecipeLink = ({ itemId }) => {
  const [count, setCount] = useState(null);
  useEffect(() => {
    let alive = true;
    api.get(`/admin/kitchen/recipes/${itemId}`)
      .then(({ data }) => alive && setCount((data.recipe?.lines || []).length))
      .catch(() => alive && setCount(0));
    return () => { alive = false; };
  }, [itemId]);
  return (
    <a
      href={`/admin/kitchen?tab=recipes&item=${encodeURIComponent(itemId)}`}
      target="_blank"
      rel="noreferrer"
      data-testid="menu-editor-recipe-link"
      className="mt-3 self-start w-fit inline-flex items-center gap-2 rounded-full bg-white/10 hover:bg-brand-gold hover:text-brand-charcoal text-white px-3.5 py-1.5 text-[11px] font-bold uppercase tracking-[0.12em] transition-colors"
    >
      <ChefHat className="h-3.5 w-3.5" />
      {count === null ? "Recipe" : count > 0 ? `Recipe · ${count} ingredient${count === 1 ? "" : "s"}` : "Add Recipe"}
      <ExternalLink className="h-3 w-3 opacity-70" />
    </a>
  );
};
